import type { BadgeProps } from '@eliadmin/core/src/components/ui/badge';
import { Badge } from '@eliadmin/core/src/components/ui/badge';
import { useCartQueryOpts } from '@eliadmin/core/src/hooks/cart/use-cart';
import { useCustomerStore } from '@eliadmin/core/src/stores/customer-store';
import { cn } from '@eliadmin/core/src/utils/style-utils';
import { useQuery } from '@tanstack/react-query';

export type CartBadgeProps = BadgeProps & {
  className?: string;
};
// TODO: fix styling on long texts ?
export function CartBadge({ className, ...props }: CartBadgeProps) {
  const me = useCustomerStore(state => state.me);
  const { data: cart } = useQuery({ ...useCartQueryOpts(), enabled: !!me?.authToken });

  if (!cart?.count) return null;

  const countText =
    cart?.count > 99 ? (
      <span>
        99<sup>+</sup>
      </span>
    ) : (
      cart?.count
    );

  return (
    <Badge
      className={cn(
        'absolute right-0 top-0 -translate-y-1/2 translate-x-1/2 justify-center !rounded-[6px] bg-primary text-[10px] font-normal leading-[1.4] text-white',
        'ea-cart-button__badge',
        className,
      )}
      {...props}
    >
      {countText}
    </Badge>
  );
}
